/*
 * @Description: 获取链接中来源渠道
 * @Author: shiduobin
 * @Date: 2025-12-29 16:12:03
 * @LastEditors: shiduobin
 * @LastEditTime: 2026-01-13 11:14:51
 */

import { getSessionStorage, setSessionStorage } from '@/utils/sessionStorage'
import { getUrlParams } from './routerUrlTransform'

/**
 * 渠道参数 key
 */
const STORAGE_CHANNEL_KEY = 'pub_channel_type'

/**
 * 接口公参渠道参数映射
 */
export const UTM_SOURCE_MAP = {
  /**
   * 从 Google Map 搜索跳转
   */
  10: 'GOOGLE_MAP',
  /**
   * 从搜索引擎跳转
   */
  19: 'SEO',
  /**
   * 其他渠道
   */
  OTHER: 'OTHER',
}

/**
 * Passport 渠道参数映射
 */
export const PASSPORT_CHANNEL_MAP = {
  /**
   * 从 Google Map 搜索跳转
   */
  10: 'google_map',
  /**
   * 其他渠道
   */
  OTHER: '',
}

/**
 * @description: 设置渠道参数到 sessionStorage
 * @return {string} 渠道参数值
 */
const setReferrerChannel = () => {
  try {
    const params = getUrlParams()
    const _channel = params?.channel || getSessionStorage(STORAGE_CHANNEL_KEY) || ''
    setSessionStorage(STORAGE_CHANNEL_KEY, _channel)
    return _channel
  } catch (error) {
    console.error('[SetReferrerChannelError]:', error)
    return ''
  }
}

/**
 * @description: 从 url 中获取渠道参数，不存在则从 sessionStorage 获取
 * @return {string} 渠道参数值
 */
const getReferrerChannel = () => {
  try {
    const params = getUrlParams()
    const _channel = params?.channel || getSessionStorage(STORAGE_CHANNEL_KEY) || ''
    return _channel
  } catch (error) {
    console.error('[GetReferrerChannelError]:', error)
    return ''
  }
}

/**
 * @description: 获取渠道参数类型
 * @param {string} channel 渠道参数值，默认从 sessionStorage 获取
 * @return {string} 渠道参数类型
 */
const getReferrerChannelType = channel => {
  try {
    const _channel = channel || getReferrerChannel()
    return UTM_SOURCE_MAP[_channel] || UTM_SOURCE_MAP.OTHER
  } catch (error) {
    console.error('[GetReferrerChannelTypeError]:', error)
    return UTM_SOURCE_MAP.OTHER
  }
}

/**
 * @description: 获取 passport 渠道参数类型
 * @param {string} channel 渠道参数值，默认从 sessionStorage 获取
 * @return {string} 渠道参数类型
 */
const getPassportChannelType = channel => {
  try {
    const _channel = channel || getReferrerChannel()
    return PASSPORT_CHANNEL_MAP[_channel] || PASSPORT_CHANNEL_MAP.OTHER
  } catch (error) {
    console.error('[GetPassportChannelTypeError]:', error)
    return PASSPORT_CHANNEL_MAP.OTHER
  }
}

export {
  setReferrerChannel,
  getReferrerChannel,
  getReferrerChannelType,
  getPassportChannelType,
  STORAGE_CHANNEL_KEY,
}
